import React, { useEffect, useState } from 'react';
import { CardHeader, CardSection } from '@europrocurement/flexy-components';
import { DOC_TYPE_INTERNAL } from '@europrocurement/l2d-domain';
import { useDossierDocumentsCtx } from '@europrocurement/l2d-modules/providers';
import RequiredDocumentsList from '../RequiredDocumentsList/RequiredDocumentsList';
import useDossierFile from '../../../hooks/useDossierFile';
import RequiredDocumentUploader from '../RequiredDocumentUploader/RequiredDocumentUploader';
import { DisplayedDocument } from '../../../providers/types';

const InternalDocumentsTab: React.FunctionComponent<React.PropsWithChildren> = function ({
    children,
}) {
    const [listItems, setListItems] = useState<Array<DisplayedDocument>>([]);
    const { dosDocs, getDossierDocumentsByCategory } = useDossierDocumentsCtx();

    const {
        handleAddFile,
        handleRemoveFile,
        handleShow,
        handleDownload,
        handleAdditionalUploads,
        handleMoveFile,
        submittingItemId,
    } = useDossierFile({
        typeDoc: DOC_TYPE_INTERNAL,
    });

    const isSubmitting = submittingItemId !== null;

    useEffect(() => {
        setListItems([
            ...getDossierDocumentsByCategory({ categoryId: DOC_TYPE_INTERNAL }),
            ...getDossierDocumentsByCategory({
                categoryId: DOC_TYPE_INTERNAL,
                additionalDocs: true,
            }),
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dosDocs]);

    return (
        <CardSection
            sx={{ width: '100%' }}
            header={
                <CardHeader
                    title="Documents internes"
                    titleSx={{
                        fontSize: '20px',
                        lineHeight: '28px',
                    }}
                    border={false}
                />
            }
            sxContent={{
                padding: '8px 8px 32px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px 0',
                width: '100%',
            }}
        >
            <RequiredDocumentsList
                documents={listItems}
                onUpload={handleAddFile}
                onDeletion={handleRemoveFile}
                onDownload={handleDownload}
                onShow={handleShow}
                onMove={handleMoveFile}
                onDocDeletion={() => {}}
                isSubmitting={isSubmitting}
                submittingItemId={submittingItemId}
            />

            <RequiredDocumentUploader
                uploading={submittingItemId === 'uploader'}
                disabled={isSubmitting}
                onChange={handleAdditionalUploads}
                typeDoc={DOC_TYPE_INTERNAL}
                additionnalAccept=",application/vnd.ms-outlook,.msg"
            />

            {children}
        </CardSection>
    );
};

export default InternalDocumentsTab;
